import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
import stepListSectionStep from '../objects/stepListSectionStep.js';
import arrayEntry from '../fragments/arrayEntry.js';
var schema = defineObject('stepListSection', {
    title: {
        title: 'Title',
        type: 'string'
    },
    cards: {
        title: 'Cards',
        type: 'array',
        of: [
            {
                type: 'stepListSectionStep'
            }
        ]
    }
}, [
    stepListSectionStep.schema.stepListSectionStep
]);
var validator = z.object({
    title: z.string(),
    cards: z.array(stepListSectionStep.validator.merge(arrayEntry.validator))
}).partial();
schema.stepListSection;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=stepListSection.js.map